module.exports = __webpack_public_path__ + "static/media/waterSplash.9eb98757.mp3";